var _a;
var FILE_TYPE;
(function (FILE_TYPE) {
    FILE_TYPE[FILE_TYPE["UNKNOWN"] = -1] = "UNKNOWN";
    FILE_TYPE[FILE_TYPE["WORD"] = 0] = "WORD";
    FILE_TYPE[FILE_TYPE["EXCEL"] = 1] = "EXCEL";
    FILE_TYPE[FILE_TYPE["SLIDE"] = 4] = "SLIDE";
})(FILE_TYPE || (FILE_TYPE = {}));
var PadStatus;
(function (PadStatus) {
    PadStatus["NEW"] = "new";
    PadStatus["LOCAL"] = "local";
    PadStatus["DELETED"] = "deleted";
    PadStatus["NORMAL"] = "normal";
})(PadStatus || (PadStatus = {}));
export var TYPE_DES;
(function (TYPE_DES) {
    TYPE_DES["SHEET"] = "sheet";
    TYPE_DES["WORD"] = "doc";
    TYPE_DES["FORM"] = "form";
    TYPE_DES["SLIDE"] = "slide";
})(TYPE_DES || (TYPE_DES = {}));
export var typeMap = (_a = {},
    _a[FILE_TYPE.EXCEL] = TYPE_DES.SHEET,
    _a[FILE_TYPE.WORD] = TYPE_DES.WORD,
    _a[FILE_TYPE.SLIDE] = TYPE_DES.SLIDE,
    _a);
export var LIST_TYPE;
(function (LIST_TYPE) {
    LIST_TYPE[LIST_TYPE["MY_DOC"] = 5] = "MY_DOC";
    LIST_TYPE[LIST_TYPE["RECENT"] = 6] = "RECENT";
    LIST_TYPE[LIST_TYPE["SHARE"] = 4] = "SHARE";
    LIST_TYPE[LIST_TYPE["STAR"] = 7] = "STAR";
    LIST_TYPE[LIST_TYPE["TRASH"] = 3] = "TRASH"; // 回收站
})(LIST_TYPE || (LIST_TYPE = {}));
export var LIST_INFO_TYPE;
(function (LIST_INFO_TYPE) {
    LIST_INFO_TYPE[LIST_INFO_TYPE["FILE"] = 1] = "FILE";
    LIST_INFO_TYPE[LIST_INFO_TYPE["FOLDER"] = 2] = "FOLDER"; // 文件夹
})(LIST_INFO_TYPE || (LIST_INFO_TYPE = {}));
var PadInfo = /** @class */ (function () {
    function PadInfo(user, isMydoc, isRencent) {
        this.folder_id = ''; // 文件夹id, 只有文件夹才有
        this.attribute = null;
        this.parents = [];
        this.isOfflineCache = false; //  是否离线缓存
        this.isSnapShot = false; //  是否渲染了快照
        // 文档权限 0 私有，1 与部分人共享 2 获得链接人可查看  3 获得链接人可编辑
        this.doc_policy = 0;
        this.folder_policy = 0;
        this.doc_privilege = null;
        this.folder_privilege = null;
        // 是否添加到我的文档
        this.is_added_my = 0;
        // 是否为星标文档
        this.is_collected = 0;
        // 当前用户是否为所有者
        this.is_owner = 1;
        // 是否置顶
        this.is_pinned = 0;
        // 是否为快捷方式
        this.is_shortcut = 0;
        // 是否手动离线
        this.isManualOffline = false;
        // 是否手动修改标题
        this.isUserChangeTitle = false;
        this.add_list_ts = 0;
        this.last_collect_ts = 0;
        this.last_delete_ts = 0;
        this.last_pinned_ts = null;
        var now = new Date().getTime() / 1000;
        this.last_browse_ts = now;
        this.last_modify_ts = now;
        this.create_ts = now;
        this.list_type = LIST_TYPE.MY_DOC;
        this.list_info_type = LIST_INFO_TYPE.FILE;
        this.owner_uid = user.getUserId();
        this.owner_nick = user.getUserId();
        this.uid = user.getUserId();
        this.last_modify_nick = user.getUserId();
        this.last_modify_uid = user.getUserId();
        if (typeof (isMydoc) !== 'undefined') {
            this.isMydoc = isMydoc;
        }
        if (typeof (isRencent) !== 'undefined') {
            this.isRencent = isRencent;
        }
    }
    return PadInfo;
}());
export { FILE_TYPE, PadStatus, PadInfo };
//# sourceMappingURL=PadInfo.js.map